import React, { Component } from 'react';
import { connect } from 'react-redux';

import { orderSingleFetch } from './../store/orderSingle/actions';
import {
    ordersDetailsFetchIfNeeded,
    ordersSetViewedFetchIfNeeded,
    ordersFilesFetchIfNeeded,
    ordersSetFavoriteFetch,
    ordersSetStatusAcceptedFetch,
    ordersSetStatusCompletedFetch,
    ordersMessagesFetch,
    ordersMessagesSetReadFetch,
    ordersMessagesAddFetch,
    orderFilesUploadFetch,
    ordersMessagesAddAttachFetch,
    ordersFilesRemoveFetch
} from './../store/orders/actions';

import Order from './../components/order/Order';
import CommonFooter from './../components/CommonFooter';
import OrderNaModal from './../components/order/OrderNaModal';

const mapStateToPropsOrder = (state, ownProps) => {
    const orderNumber = ownProps.orderNumber;
    const order = state.orders[orderNumber];
    const hasOrderInList = !!order;
    const error = hasOrderInList ? order.error : null;
    const isFilesLoading = !hasOrderInList || !order.files || order.files.isFetching || order.files.didInvalidate;
    const isMessagesLoading = !hasOrderInList || !order.messages || order.messages.isFetching || order.messages.didInvalidate;
    const isLoading = !hasOrderInList || order.isFetching || order.didInvalidate || isFilesLoading || isMessagesLoading;
    const fileItems = !hasOrderInList || !order.files || !order.files.items ? {} : order.files.items;
    const messageList = !hasOrderInList || !order.messages || !order.messages.items ? [] : Object.values(order.messages.items);
    const isLoadingAdd = !hasOrderInList || !order.messages ? true : order.messages.isFetchingAdd;
    const isStatusLoading = hasOrderInList && order.isFetchingStatus;
    return { hasOrderInList, isLoading, order, error, fileItems, isStatusLoading, messageList, isLoadingAdd };
};

const mapDispatchToPropsOrder = (dispatch, ownProps) => {
    const orderNumber = ownProps.orderNumber;

    return {
        loadDetails: () => {
            dispatch(ordersDetailsFetchIfNeeded(orderNumber));
            dispatch(ordersSetViewedFetchIfNeeded(orderNumber));
            dispatch(ordersFilesFetchIfNeeded(orderNumber));
            dispatch(ordersMessagesFetch(orderNumber));
        },
        setFavorite: value => dispatch(ordersSetFavoriteFetch(orderNumber, value)),
        setAccepted: () => dispatch(ordersSetStatusAcceptedFetch(orderNumber)),
        setCompleted: () => dispatch(ordersSetStatusCompletedFetch(orderNumber)),
        setMessageRead: messageId => dispatch(ordersMessagesSetReadFetch(orderNumber, messageId)),
        addMessage: (to, message) => dispatch(ordersMessagesAddFetch(orderNumber, to, message)),
        uploadFile: (file, group) => dispatch(orderFilesUploadFetch(orderNumber, file, group)),
        addMessageAttach: (to, files, message) => dispatch(ordersMessagesAddAttachFetch(orderNumber, to, files, message)),
        removeFile: fileId => dispatch(ordersFilesRemoveFetch(orderNumber, fileId)),
    };
};

const OrderStandalone = connect(mapStateToPropsOrder, mapDispatchToPropsOrder)(Order);

class OrderStandalonePage extends Component {
    componentDidMount() {
        const { load } = this.props;
        load();
    }

    renderOrder() {
        const { number, error, history } = this.props;
        if (error) {
            return (<OrderNaModal onClose={() => { history.replace('/'); }} />);
        }
        if (!number) {
            return null;
        }
        return (
            <OrderStandalone standalone orderNumber={number} onSelect={() => { history.replace('/'); }} />
        );
    }

    render() {
        const { isLoading } = this.props;
        return (
            <div className="order-standalone-page single-page">
                <a href="/" className="logo"> </a>
                <section className="container single-page-container">
                    {isLoading
                        ? <h1>loading</h1>
                        : this.renderOrder()
                    }
                </section>
                <CommonFooter />
            </div>
        );
    }
}

const mapStateToProps = state => {
    const number = state.orderSingle.number;
    const isLoading = state.orderSingle.isFetching;
    const error = state.orderSingle.error;
    return { isLoading, number, error };
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        load: () => dispatch(orderSingleFetch(ownProps.match.params.id)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(OrderStandalonePage);



// WEBPACK FOOTER //
// ./src/pages/OrderStandalonePage.js